"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueStatus = void 0;
var QueueStatus;
(function (QueueStatus) {
    QueueStatus["complete"] = "complete";
    QueueStatus["incomplete"] = "incomplete";
    QueueStatus["zipping"] = "zipping";
})(QueueStatus = exports.QueueStatus || (exports.QueueStatus = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/reports.ts
// module id = 3950
// module chunks = 0